<template>
  <v-row>
    <v-col cols="12">
        <v-textarea
            v-model="jsonData"
            label="Raw JSON"
            rows="2"
            autocomplete="off"
        ></v-textarea>

        <v-textarea
          :value="outputs"
          label="Formatted JSON"
          rows="2"
          autocomplete="off"
        ></v-textarea>

        <pre style="font-family: Roboto">{{ outputs }}</pre>

    </v-col>
  </v-row>
</template>


<script>
import { ref, computed } from '@vue/composition-api'

export default {
  setup() {
    let jsonData = ref('')

    let outputs = computed(() => {
      try {
        if ('' == jsonData.value) {
          return ''
        }

        let data = jsonData.value.split("\n")

        data = data.map(line => line.trimStart())
        data = data.join('')
        data = JSON.parse(data)

        return JSON.stringify(data, function(key, value) {
          if ('string' == typeof value) {
            //if (value.startsWith('data:') || value.startsWith('image/')) {
              //return "< R E M O V E D >"
            //}

            if (value.length > 100) {
              return value.substr(0, 96) + '...'
            }
          }

          return value
        }, 4)

      } catch (e) {
        console.log(e)
        return e
      }
    })

    return {
      jsonData,
      outputs,
    }
  },
}
</script>

<style scoped>

</style>

